export const NOTIFICATION_VARIABLES_WITH_LINK = ['candidateName', 'jobTitle']
